import { render, staticRenderFns } from "./ImageTranslate.vue?vue&type=template&id=0961df72&scoped=true"
import script from "./ImageTranslate.vue?vue&type=script&lang=js"
export * from "./ImageTranslate.vue?vue&type=script&lang=js"
import style0 from "./ImageTranslate.vue?vue&type=style&index=0&id=0961df72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961df72",
  null
  
)

export default component.exports